<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div :class="[state === 'filling' ? 'panel' : 'panel--bg small']">
                    <div class="panel__header"></div>
                    <div class="panel__body panel__body--review">
                        <template v-if="state === 'loading'">
                                <div class="spinner"></div>
                        </template>

                        <template v-else-if="state === 'invalid_token'">
                            <i class="icons icon-close"></i>
                            <p>{{$t('trajectory_review.invalid')}}</p>
                        </template>

                        <template v-else-if="state === 'filling'">
                            <h1>{{survey.survey_template.title}}</h1>
                            <h2>
                                {{ $t('survey_template.type')}}:
                                {{ $t('forms.survey_template.types.' + survey.survey_template.type)}}
                            </h2>
                            <br/>

                            <div class="panel__list">
                                <div class="panel__list__item" v-for="(question, index) in survey.survey_template.questions" :key="question.id">
                                    <h3>{{question.description}} {{question.required ? '*' : ''}}</h3>
                                    <component :is="`survey-question-${question.type}-form`" v-model="survey.survey_template.questions[index]" :locked="false" />
                                </div>

                                <div class="panel__list__item__default-action">
                                    <a class="button--link" @click="reset">{{$t('forms.common.reset')}}</a>
                                    <a class="button--link--cta" @click="submit" :class="{disabled: isSubmitDisabled}" :disabled="isSubmitDisabled" >{{$t('forms.common.submit')}}</a>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="state === 'invalid'">
                            <h1>{{$t('survey_fill.invalid')}}</h1>
                            <i class="icons icon-close"></i>
                            <p>{{$t('survey_fill.invalid_text')}}</p>
                            <button class="button--alt" type="button" @click="state = 'filling'">{{$t('common.back')}}</button>
                        </template>

                        <template v-else-if="state === 'submitted'">
                            <h1>{{$t('survey_fill.submitted')}}</h1>
                            <i class="icons icon-check"></i>
                            <p>{{$t('survey_fill.submitted_text')}}</p>
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.panel__list__item__default-action {
    text-align: right;
}
</style>


<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import SurveyQuestionLikertForm from '@/components/forms/survey/SurveyQuestionLikertForm';
    import SurveyQuestionMultipleForm from '@/components/forms/survey/SurveyQuestionMultipleForm';
    import SurveyQuestionOpenForm from '@/components/forms/survey/SurveyQuestionOpenForm';
    import SurveyQuestionScaleForm from '@/components/forms/survey/SurveyQuestionScaleForm';

    @Component({
        components: {
            SurveyQuestionLikertForm,
            SurveyQuestionMultipleForm,
            SurveyQuestionOpenForm,
            SurveyQuestionScaleForm,
        }
    })
    export default class SurveyFill extends Vue {
        name = 'survey-fill';
        state = 'loading';
        isClient = true;
        survey = {};

        created() {
            this.isClient = this.$route.name === 'survey-client';
            this.token = this.$route.params.token;
            if (this.token) {
                this.fetchSurveyData();
            } else {
                this.$router.replace({name: 'page_not_found'});
            }
        }

        fetchSurveyData() {
            this.axios.get(`/surveys/${this.token}`)
                .then(res => {
                    this.survey = res.data;
                    this.state = 'filling';
                })
                .catch(err => {
                    let errorMsg = err.status === 404 && err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.general_error');
                    this.$notify.error(errorMsg);
                    this.state = 'invalid_token';
                });
        }

        submit() {
            this.state = 'loading';
            this.survey.answers = [];
            this.survey.survey_template.questions.forEach(q => {
                if (q.answer) {
                    this.survey.answers.push({survey_question_id: q.id, answer: q.answer});
                }
            });

            this.axios.post(`/surveys/${this.token}/`, this.survey)
                .then(res => {
                    this.state = 'submitted';
                })
                .catch(err => {
                    let errorMsg = err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.general_error');
                    this.$notify.error(errorMsg);
                    this.state = 'invalid';
                });
        }

        get isSubmitDisabled() {
            return this.survey.survey_template.questions.some(q => q.required && !q.answer);
        }

        reset() {
            this.fetchSurveyData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/SurveyFill.vue